import { render, staticRenderFns } from "./SiswaPlanAngsuran.vue?vue&type=template&id=68a934ef&scoped=true"
import script from "./SiswaPlanAngsuran.vue?vue&type=script&lang=js"
export * from "./SiswaPlanAngsuran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a934ef",
  null
  
)

export default component.exports